var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import PropTypes from 'prop-types';

import TextField from '@material-ui/core/TextField';

import DatePicker from 'react-datepicker';

import moment from 'moment/moment';

import 'react-datepicker/dist/react-datepicker.css';

var MuiDateInput = function (_React$Component) {
    _inherits(MuiDateInput, _React$Component);

    function MuiDateInput() {
        _classCallCheck(this, MuiDateInput);

        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
    }

    MuiDateInput.prototype.render = function render() {
        var props = this.props;

        var value = props.value,
            readonly = props.readonly,
            disabled = props.disabled,
            autofocus = props.autofocus,
            onBlur = props.onBlur,
            onFocus = props.onFocus,
            options = props.options,
            schema = props.schema,
            formContext = props.formContext,
            registry = props.registry,
            onClick = props.onClick,
            inputProps = _objectWithoutProperties(props, ['value', 'readonly', 'disabled', 'autofocus', 'onBlur', 'onFocus', 'options', 'schema', 'formContext', 'registry', 'onClick']);

        return React.createElement(TextField, _extends({
            onClick: onClick,
            margin: 'none',
            readOnly: readonly,

            autoFocus: autofocus,
            value: value || ''
        }, inputProps, {
            onBlur: onBlur && function (event) {
                return onBlur(inputProps.id, event.target.value);
            },
            onFocus: onFocus && function (event) {
                return onFocus(inputProps.id, event.target.value);
            },
            disabled: disabled,
            inputProps: {
                style: { width: '100%' }
            },
            fullWidth: true
        }));
    };

    return MuiDateInput;
}(React.Component);

function ReactDatePicker(props) {
    var value = props.value,
        options = props.options,
        onBlur = props.onBlur,
        onFocus = props.onFocus,
        schema = props.schema,
        readonly = props.readonly,
        inputProps = _objectWithoutProperties(props, ['value', 'options', 'onBlur', 'onFocus', 'schema', 'readonly']);

    var onChange = function onChange(value) {
        if (!value) {
            return props.onChange(options.emptyValue);
        }

        var completeDate = moment();
        completeDate.date(value.get('date')).month(value.get('month'));

        return props.onChange(completeDate.format());
    };

    var newVal = !value ? undefined : moment(value);

    return React.createElement(DatePicker, {
        customInput: React.createElement(MuiDateInput, inputProps),
        selected: newVal,
        disabled: schema.disabled || readonly,
        onChange: onChange,
        isClearable: !(schema.disabled || readonly),
        onBlur: onBlur && function () {
            return onBlur(inputProps.id);
        },
        onFocus: onFocus && function () {
            return onFocus(inputProps.id);
        }
    });
}

ReactDatePicker.defaultProps = {
    type: 'text',
    required: false,
    disabled: false,
    readonly: false,
    autofocus: false
};

ReactDatePicker.propTypes = process.env.NODE_ENV !== "production" ? {
    id: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    value: PropTypes.any,
    required: PropTypes.bool,
    disabled: PropTypes.bool,
    readonly: PropTypes.bool,
    autofocus: PropTypes.bool,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    onFocus: PropTypes.func
} : {};

export default ReactDatePicker;